import { toast } from 'sonner';
import { SnackbarNotification } from '../model/notification.types';

export { Toaster } from 'sonner';

// Plain function, so it also works outside React (e.g. in redux middleware).
// Notifications with the same id replace each other instead of stacking.
export const notify = ({ message, type, id }: SnackbarNotification) => {
    switch (type) {
        case 'success':
            toast.success(message, { id });
            break;
        case 'error':
            toast.error(message, { id });
            break;
        case 'warning':
            toast.warning(message, { id });
            break;
        default:
            toast(message, { id });
    }
};
